import { Component, OnInit, OnDestroy } from '@angular/core';
import {AppDataService} from "../../../services/app-data.service";
import {FormBuilder, FormGroup} from "@angular/forms";
import {CompanyService} from "../../../services/company.service";
import { TranslationService } from '../../../services/translation.service';


declare let $: any;
declare let Swal:any;

@Component({
    selector : 'item-triggers',
    templateUrl:'itemTriggers.html'
})
export class ItemTriggerComponent implements OnInit{

  public action;
  public option: string;
  public hand:string;
  public actionOption: string;
  public trigger;
  public actionIndex;
  public triggers;
  public showActionOptions
  public showTable;
  public distanceForm: FormGroup;
  public onClickThumbs=[
    {name:'Popup Link',kind:'openLink'},
    {name:'Sentar',kind:'sittable'},
    {name:'Abrir vídeo',kind:'videoShow'},
    {name:'Trocar avatar',kind:'avatarChange'},
    {name:'Iniciar audio',kind:'audioShow'},
    {name:'Abrir imagem',kind:'imageShow'},
    {name:'NPC',kind:'npcTalk'},
    {name:'Embedar url',kind:'embed'},
    {name:'Container de itens',kind:'container'},
    {name:'Porta',kind:'door'},
    {name:'Missões',kind:'writAction'},
    {name:'walkAnimation',kind:'walkAnimation'},
    {name:'Adicionar Itens',kind:'addItens'},
    {name:'Remover Itens',kind:'removeItens'},
    {name:'Texto',kind:'text'},


  ]
  public onCloseThumbs=[
    {name:'Popup Link',kind:'openLink'},
    {name:'Sentar',kind:'sittable'},
    {name:'Abrir vídeo',kind:'videoShow'},
    {name:'Iniciar audio',kind:'audioShow'},
    {name:'Abrir imagem',kind:'imageShow'},
    {name:'NPC',kind:'npcTalk'},
    {name:'Embedar url',kind:'embed'},
    {name:'Conversar',kind:'talk'},
    {name:'Animação',kind:'animation'},
    {name:'particles',kind:'particles'},
    {name:'spotLight',kind:'spotLight'},   
    {name:'water',kind:'water'},   
    {name:'walkAnimation',kind:'walkAnimation'},
    {name:'panoramaShow',kind:'panoramaShow'},
    {name:'Caminhar',kind:'walkArea'},
    {name:'Roupa',kind:'cloth'},
    {name:'Texto',kind:'text'}

  ]
  public onGrabThumbs=[
    {name:'Movivel',kind:'movable'},
    {name:'Roupa',kind:'cloth'},
    {name:'Equipavel',kind:'equipable'},
    {name:'Iniciar audio',kind:'audioShow'},
    {name:'Containable',kind:'containable'},
    {name:'Adicionar Itens',kind:'addItens'},
    {name:'Remover Itens',kind:'removeItens'},

  ]
  public onHandClickThumbs=[
    {name:'Iniciar audio',kind:'audioShow'},
    {name:'Remove Itens',kind:'removeItens'},
    {name:'particles',kind:'particles'},
  ]

  public onOverThumbs=[
    {name:'Tooltip',kind:'tooltip'},
    {name:'Shine',kind:'shine'},
    {name:'Animation',kind:'animation'},
    {name:'Sound',kind:'sound'},
  ]
  public constructor(public translate: TranslationService,public _appData : AppDataService,private fb : FormBuilder, private _companyService : CompanyService) {
    this.option='';
    this.actionOption='';
    this.trigger=[]
    this.showActionOptions=false;
    this.distanceForm = this.fb.group({
      dXParam: 0,
      dYParam: 0,
    });
    this._appData.npcTriggers=null
  }
  public selectOption(option){
    this.option=option;
    if (!this.triggers[option]){this.triggers[option]=[]}
    this.trigger=this.triggers[option];
    this._appData.activeTrigger=option;
    this.showTable=true;
    this.showActionOptions=false
    this.action=null
  }
  public selectHand(hand){
    this.hand=hand;
    this.trigger.forEach(act=>{
      act.param.hand=hand
    })
    this._appData.triggers=this.triggers;
    document.getElementById('item-trigger-reload').click();
    document.getElementById('recipe-trigger-reload').click();
  }

  public selectActionOption(action){
    this.trigger.push({
      kind:action.kind,
      param:{}
    })
    this.triggers[this.option]=this.trigger;
    this._appData.triggers=this.triggers;
    this.showActionOptions=false
    this.showTable=true;
    document.getElementById('item-trigger-reload').click();
    document.getElementById('recipe-trigger-reload').click();
  }
  public addAction(){
    this.showTable=false;
    this.showActionOptions=true
  }
  public editAction(j){
    let action=this.trigger[j]   
    this.showTable=false;
    this.action=action.kind;
    this._appData.action=action;
    this.actionIndex=j;
    if (action.triggers){
      this._appData.secondTriggers=action.triggers;
    }
    else{
      this._appData.secondTriggers={}
    }
    setTimeout(()=>{
      document.getElementById('action-'+action.kind+'-reload').click();
    },1000)
    this.distanceForm = this.fb.group({
      dXParam: action.param.dx ? action.param.dx:0,
      dYParam: action.param.dy ?action.param.dy:0
    })

  }
  public updateDistance() {
    let x = this.distanceForm.controls['dXParam'].value;
    let y = this.distanceForm.controls['dYParam'].value;
    
    this._appData.action.param.dx = x;
    this._appData.action.param.dy = y;

  }
  public actionDone(){
    this.action=null;
    this.trigger[this.actionIndex]=this._appData.action;
    this._appData.action=null;
    this.triggers[this.option]=this.trigger;
    this._appData.triggers=this.triggers;
    this.showTable=true;
    document.getElementById('item-trigger-reload').click();
    document.getElementById('recipe-trigger-reload').click();
  }
  public removeAction(j){
    this.trigger.splice(j,1)
    document.getElementById('item-trigger-reload').click();
    document.getElementById('recipe-trigger-reload').click();
  }
  public reload(){
    this.triggers = this._appData.triggers;
    
    if (!this.triggers){
      this.triggers={}
    }
    this.showActionOptions=false
    this.action=null
    this.showTable=false;
    this.trigger=[];

    document.getElementById('item-trigger-reload').click();
    document.getElementById('recipe-trigger-reload').click();

  }
  public ngOnInit(): any {
      this.triggers = this._appData.triggers;
      if (!this.triggers){
        this.triggers={}
      }
  }


}



// WEBPACK FOOTER //
// C:/prj/liveplanet-app-site/src/app/components/+gameevent/triggers/itemTriggers.ts